require('./brokerSearch.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @components
const BrokerSearchInput = require('./brokerSearchInput/brokerSearchInput');
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');

// @helpers
const {formatText, FormattedText} = require('core/i18n').i18n;
const { getPublicSitePathByLanguaje } = require('core/apiURLBuilder');

// @constants
const {TYPE_STOCKS, TYPE_PLANS, TYPE_WARRANTS, TYPE_FUNDS, TYPE_ETFS} = require('constants/index');

class BrokerSearch extends React.Component {
    constructor(props) {
        super(props);
        this.handleProduct = this.handleProduct.bind(this);
        this.search = this.search.bind(this);
    }

    handleProduct(option) {
        let url = '';

        switch (option.type) {
            case TYPE_FUNDS:
                url = `/myprofile/broker/fund/isin/${option.instrumentId}`;
                break;
            case TYPE_PLANS:
                window.location.href = getPublicSitePathByLanguaje('brokerURL-brokerURL_pensionPlanOnPublic', {isin: option.instrumentId});
                return;
            case TYPE_ETFS:
                url = `/myprofile/broker/etfsProductFile/${option.id.isin}/${option.id.iso}`;
                break;
            case TYPE_STOCKS:
                url = `/myprofile/broker/productFile/${option.id.isin}/${option.id.iso}`;
                break;
            case TYPE_WARRANTS:
                url = `/myprofile/broker/warrantsProductFile/${option.id.isin}/${option.id.iso}`;
                break;
            default: // See more link
                url = '/myprofile/broker/explore';
                const {singlePlanSearchSelector, selectFilter, onSeeMore, searchState} = this.props;
                if(singlePlanSearchSelector && selectFilter){
                    selectFilter(singlePlanSearchSelector);
                }
                if (onSeeMore) {
                    onSeeMore(searchState.get('term'));
                }
                break;
        }

        this.props.history.push(url);
    }

    search() {
        const { history, searchState, changeTab, performSimpleSearch, selectFilter, singlePlanSearchSelector } = this.props;
        history.push('/myprofile/broker/explore');
        const term = searchState.get('term');
        changeTab(0);
        if(singlePlanSearchSelector && selectFilter){
            selectFilter(singlePlanSearchSelector);
        }
        performSimpleSearch(term);
    }

    render() {
        const {searchState, onHandleSearch, onHandleSearchReset, modifier, startResultsScrollAtTop, singlePlanSearchSelector, searchTitle, searchPlaceholder} = this.props;
        const isLoading = searchState.get('isFetching');
        const results = searchState.get('results');
        const term = searchState.get('term');
        const plansList = singlePlanSearchSelector ? [singlePlanSearchSelector] : [TYPE_STOCKS, TYPE_WARRANTS, TYPE_ETFS, TYPE_FUNDS, TYPE_PLANS];
        const buttonDisabled = (results.size === 0 || !term ? true : false);

        const searchEmptyText = formatText('broker-searchEmptyText');
        const advancedSearchUrl = singlePlanSearchSelector ? '/myprofile/broker/explore/'+ singlePlanSearchSelector : '/myprofile/broker/explore/';
        const icon = isLoading ? <div className="Select-loading broker-search__select-loading" /> : <button disabled={buttonDisabled} className="icon-buscar" onClick={() => this.search()}></button>
        return (
            <ContentBox
                id="brokerMarketTrends"
                title={searchTitle}
                customClassName="broker-search"
                smallTitle={true}
                modifier="complementary-highlighted"
            >
                <div className="broker-search__select-wrapper">
                    <BrokerSearchInput
                        results={results}
                        term={term}
                        pageSize={10}
                        plansToReturn={plansList}
                        isLoading={false}
                        onSelection={this.handleProduct}
                        onSearch={onHandleSearch}
                        onReset={onHandleSearchReset}
                        noResultsText={searchEmptyText}
                        placeholder={searchPlaceholder}
                        modifier={modifier}
                        startResultsScrollAtTop={startResultsScrollAtTop}
                        resetWhenMounting={true}
                    />
                    <div className="broker-search__search-icon">
                        {icon}
                    </div>
                </div>
                <div className="broker-search__link-box">
                    <OKLink to={advancedSearchUrl} modifier="widget">
                        <FormattedText value="broker-advancedSearchLink" />
                    </OKLink>
                </div>
            </ContentBox>
        );
    }
}

BrokerSearch.propTypes = {
    history: PropTypes.object.isRequired,
    searchState: PropTypes.object.isRequired,
    onHandleSearch: PropTypes.func.isRequired,
    onHandleSearchReset: PropTypes.func.isRequired,
    onSeeMore: PropTypes.func,
    modifier: PropTypes.string,
    startResultsScrollAtTop: PropTypes.bool,
    changeTab: PropTypes.func.isRequired,
    performSimpleSearch: PropTypes.func.isRequired,
    singlePlanSearchSelector: PropTypes.oneOf([TYPE_STOCKS, TYPE_WARRANTS, TYPE_ETFS, TYPE_FUNDS, TYPE_PLANS]),
    searchTitle: PropTypes.string,
    searchPlaceholder: PropTypes.string,
    selectFilter: PropTypes.func
};

BrokerSearch.defaultProps = {
    searchTitle: formatText('broker-searchTitle'),
    searchPlaceholder: formatText('broker-searchPlaceholder')
};

module.exports = withRouter(BrokerSearch);
